"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatType = void 0;
var FormatType;
(function (FormatType) {
    FormatType["JSON"] = "json";
    FormatType["String"] = "string";
})(FormatType || (exports.FormatType = FormatType = {}));
